<div class="form form__container">
  <div class="form__header">
    <div class="form__label-title">{{ 'webPos.Closings.Money' | translate }}</div>
    <div class="form__subtitle">{{ 'webPos.Closings.MoneySubtitle' | translate }}</div>
  </div>

  <form [formGroup]="closingForm" class="form__content">
    <section class="form__section">
      <div class="form__info-grid">
        <div class="form__info-item">
          <span class="form__label">{{ 'webPos.Branch' | translate }}</span>
          <span class="form__text">{{ user?.BusinessUnitName }}</span>
        </div>
        <div class="form__info-item">
          <span class="form__label">{{ 'webPos.Closings.RegisterId' | translate }}</span>
          <span class="form__text">{{ user?.SelectedBusinessUnit }}</span>
        </div>
        <div class="form__info-item">
          <span class="form__label">{{ 'webPos.Closings.FullName' | translate }}</span>
          <span class="form__text">{{ user?.DisplayName }}</span>
        </div>
        <div class="form__info-item">
          <span class="form__label">{{ 'webPos.Closings.InventoryDate' | translate }}</span>
          <span class="form__text">{{ currentDate | date:'dd.MM.yyyy HH:mm:ss' }}</span>
        </div>
      </div>
    </section>

    <section class="form__section">
      <h3 class="form__section-title">{{ 'webPos.Closings.CashOnHand' | translate }}</h3>
      <div class="form__tables">
        <table class="form__table">
          <thead>
            <tr>
              <th>{{ 'webPos.Closings.BanknoteValue' | translate }} {{ currencyCode | currencymap}}</th>
              <th>{{ 'webPos.CountOfPieces' | translate }}</th>
              <th>{{ 'webPos.Closings.TotalAmount' | translate }} {{ currencyCode | currencymap}}</th>
            </tr>
          </thead>
          <tbody>
            @for (banknote of banknotes; track banknote.value; let i = $index) {
            <tr>
              <td>{{ banknote.value | number }}</td>
              <td>
                <input class="form__input" type="number" min="0" [formControlName]="'denomination_' + (banknote.value)" appSelectAllOnFocus />
              </td>
              <td>{{ banknote.total | number }}</td>
            </tr>
            }
          </tbody>
          </table>

        <table class="form__table">
          <thead>
            <tr>
              <th>{{ 'webPos.Closings.CoinValue' | translate }} {{ currencyCode | currencymap}}</th>
              <th>{{ 'webPos.CountOfPieces' | translate }}</th>
              <th>{{ 'webPos.Closings.TotalAmount' | translate }} {{ currencyCode | currencymap}}</th>
            </tr>
          </thead>
          <tbody>
            @for (coin of coins; track coin.value; let i = $index) {
            <tr>
              <td>{{ coin.value | number}}</td>
              <td>
                <input class="form__input" type="number" min="0" [formControlName]="'denomination_' + (coin.value)" appSelectAllOnFocus />
              </td>
              <td>{{ coin.total | number }}</td>
            </tr>
            }
          </tbody>
        </table>
      </div>
    </section>

    <section class="form__section">
      <h3 class="form__section-title">{{ 'webPos.Closings.Summary' | translate }}</h3>
      <div class="form__summary">
        <div class="form__summary-row">
          <span>{{ 'webPos.Closings.TotalCash' | translate }}</span>
          <span class="form__value">{{ totalValue | number }} {{ currencyCode | currencymap }}</span>
        </div>
        <div class="form__summary-row">
          <span>{{ 'webPos.Closings.BookBalance' | translate }}</span>
          <span class="form__value">{{ totalRegisteredValue| number }} {{ currencyCode | currencymap }}</span>
        </div>      
      </div>
    </section>

     @if (difference >= 0) {
        <div class="form__summary-row form__summary-row--highlight">
          @if (difference === 0) {
          <span>{{ 'webPos.Closings.Difference' | translate }}</span>
          }
          @if (difference > 0) {
          <span>{{ 'webPos.Closings.Surplus' | translate }}</span>
          }
          <span class="form__value form__value--positive">{{ surplus | number }} {{ currencyCode | currencymap }}</span>
        </div>
        }
      @if (difference < 0) {
      <div class="form__summary-row form__summary-row--highlight form__summary-row--negative">
        <span>{{ 'webPos.Closings.Shortage' | translate }}</span>
        <span class="form__value form__value--negative">{{ shortage | number }} {{ currencyCode | currencymap }}</span>
      </div>
      }

    @if (difference !== 0) {
    <section class="form__section">
       <h3 class="form__section-title">{{ 'webPos.Closings.Note' | translate }}</h3>
      <!-- <label class="form__label">{{ 'webPos.Closings.Note' | translate }}</label> -->
      <textarea class="form__textarea" formControlName="note" placeholder="{{ 'webPos.Closings.EnterNote' | translate }}"></textarea>
    </section>
    }

    <section class="form__section">
      <p class="form__note">{{ 'webPos.Closings.ConfirmationNote' | translate }}</p>
      <div class="form__footer">
        <div class="form__footer-left">
          <label class="form__checkbox">
            <input type="checkbox" id="confirm" formControlName="confirm" />
            <span>{{ 'webPos.Closings.ConfirmInputsCorrect' | translate }}</span>
          </label>
          
        </div>
        <div class="form__footer-right">
          <app-card-button
            [buttonSize]="CardButtonSize.Small"
            [buttonBackground]="CardButtonBackground.Primary"
            [disabled]="!closingForm.get('confirm')?.value || (difference !== 0 && !closingForm.get('note')?.value)"
            (clicked)="confirm(true)">
            {{ 'webPos.Confirm' | translate }}
          </app-card-button>
        </div>
      </div>
    </section>
  </form>
</div>
